import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './QrPrint.css';

// Physical sizes for printed labels (the QR is a square of this many millimetres).
const SIZES = [
  { key: 'small', label: 'Small', mm: 10 },
  { key: 'medium', label: 'Medium', mm: 25 },
  { key: 'large', label: 'Large', mm: 50 }
];

// Pick a label size and open the browser's print dialog. The sheet that gets
// printed is rendered into <body> and every other part of the page is hidden
// while printing (see QrPrint.css), so only the QR code comes out on paper.
function QrPrint({ qrCode, name }) {
  const [sizeKey, setSizeKey] = useState('medium');
  const { mm } = SIZES.find((size) => size.key === sizeKey);
  const src = `data:image/svg+xml;base64,${qrCode}`;
  const squareStyle = { width: `${mm}mm`, height: `${mm}mm` };

  return (
    <div className="qr-print">
      <div className="qr-size-options" role="radiogroup" aria-label="QR code size">
        {SIZES.map((size) => (
          <label key={size.key} className={`qr-size-option${sizeKey === size.key ? ' selected' : ''}`}>
            <input
              type="radio"
              name="qr-size"
              checked={sizeKey === size.key}
              onChange={() => setSizeKey(size.key)}
            />
            <span>{size.label}</span>
            <span className="qr-size-mm">{size.mm} mm</span>
          </label>
        ))}
      </div>

      <div className="qr-preview">
        <img src={src} alt={`QR code for ${name}`} style={squareStyle} />
      </div>

      <button type="button" className="btn btn-primary" onClick={() => window.print()}>
        Print QR code
      </button>

      {createPortal(
        <div className="qr-print-sheet">
          <img src={src} alt="" style={squareStyle} />
        </div>,
        document.body
      )}
    </div>
  );
}

export default QrPrint;
